import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openPicker() {
    if (this.element.showPicker) {
      this.element.showPicker()
    }
  }
}
